export const MAKER_SUBMISSION_REQUEST = 'MAKER_SUBMISSION_REQUEST';
export const MAKER_SUBMISSION_SUCCESS = 'MAKER_SUBMISSION_SUCCESS';
export const MAKER_SUBMISSION_FAIL = 'MAKER_SUBMISSION_FAIL';
